import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { SessionService } from 'src/app/auth/session.service';
import { safelyDetectChanges, unsubscribeAll } from 'src/app/common/app.helpers';
import AppSettings from 'src/app/common/app.settings';
import { MessengerMessage } from '../../interfaces/messenger.interface';
import { MessengerService } from '../../services/messenger.service';

@Component({
  selector: 'app-messenger-dropdown',
  templateUrl: './messenger-dropdown.component.html',
  styleUrls: ['./messenger-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessengerDropdownComponent implements OnInit, OnDestroy {
  @ViewChild('dropdown', { static: true })
  public dropdown: NgbDropdown;

  public messages: MessengerMessage[] = [];
  public conversationsLoaded = false;
  public messengerEngineConnected = false;

  private subscriptions$: Subscription[] = [];
  private messengerService = inject(MessengerService);
  private changeDetector = inject(ChangeDetectorRef);
  private router = inject(Router);
  private sessionService = inject(SessionService);
  private authService = inject(AuthService);

  public ngOnInit(): void {
    this.subscribeEventMessengerChanges();
    this.subscribeRouterChanges();
  }

  public ngOnDestroy(): void {
    unsubscribeAll(this.subscriptions$);
  }

  public is2AuthLvlPassed(): void {
    if (!this.sessionService.is2AuthLvlPassed) {
      const previousPage: string = this.router.url;
      localStorage.setItem(AppSettings.LOCALSTORE_KEY_OPEN_DROPDOWN_MESSENGER, 'true');
      this.authService.showSendMessageRefuseModal(previousPage);
    }
  }

  public get unreadChannelsCount(): number {
    return this.messages.filter((message: MessengerMessage) => message.isChannelUnread).length;
  }

  private subscribeRouterChanges(): void {
    this.subscriptions$.push(
      this.router.events.subscribe((event: Event) => {
        if (this.dropdown.isOpen() && event instanceof NavigationEnd) {
          this.dropdown.close();
          safelyDetectChanges(this.changeDetector);
        }
      }),
    );
  }

  private subscribeEventMessengerChanges(): void {
    this.subscriptions$.push(
      this.messengerService.messengerChannelConnectionStateChanged.subscribe((connected: boolean) => {
        this.messengerEngineConnected = connected;
        const openDropdown: string = localStorage.getItem(AppSettings.LOCALSTORE_KEY_OPEN_DROPDOWN_MESSENGER);
        if (openDropdown) {
          this.dropdown.open();
          localStorage.removeItem(AppSettings.LOCALSTORE_KEY_OPEN_DROPDOWN_MESSENGER);
        }
        safelyDetectChanges(this.changeDetector);
      }),
    );

    this.subscriptions$.push(
      this.messengerService.messengerChanges.subscribe((messages: MessengerMessage[]) => {
        this.messages = messages;
        this.conversationsLoaded = true;
        safelyDetectChanges(this.changeDetector);
      }),
    );
  }
}
